import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormGroup, FormText, Label, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from "reactstrap";
import Autosuggest from "react-autosuggest";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./DropDown.css";

class DropDownComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
      selected: { label: "", value: "" },
      suggestions: [],
      value: ""
    };
  }

  getValidationState = () => {
    const { isInvalid, isValid } = this.props;
    let classNameValidity = isInvalid ? "is-invalid" : "";
    classNameValidity = isValid ? "is-valid" : classNameValidity;

    return classNameValidity;
  };

  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  };

  componentWillReceiveProps = NewProps => {
    const { selected = {} } = NewProps;
    if (selected) this.setState({ selected, value: selected.label });
  };

  componentWillMount = () => {
    const { selected = { label: "", value: "" } } = this.props;
    if (selected) this.setState({ selected, value: selected.label });
  };

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });
  };

  getSuggestionValue = suggestion => suggestion.label;

  renderSuggestion = suggestion => <span>{suggestion.label}</span>;

  getSuggestions = value => {
    const escapedValue = this.escapeRegexCharacters(value.trim());
    const { options } = this.props;

    const regex = new RegExp(`^${escapedValue}`, "i");

    return options.filter(option => regex.test(option.label));
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  escapeRegexCharacters = str => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  render() {
    const { isInvalid, name, message, label, Clicked, className, helpText, options } = this.props;
    const { dropdownOpen, selected, suggestions, value } = this.state;
    const inputProps = {
      placeholder: `Type a ${label}`,
      value,
      onChange: this.onChange
    };

    if (!options) return <div />;

    if (options.length < 7)
      return (
        <FormGroup className="height-center">
          <Label className={className}>{label}</Label>
          <Dropdown
            ref={name}
            name={name || label}
            isOpen={dropdownOpen}
            direction="down"
            toggle={this.toggle}
            className={`${this.getValidationState()} ${className}`}
          >
            <DropdownToggle style={{ width: "150px" }} caret outline color="secondary" className="text-left">
              {selected && selected.label}
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem header>{`Select a ${label}`}</DropdownItem>
              {options
                .filter(item => Boolean(item))
                .map(item => (
                  <DropdownItem
                    key={item && item.value}
                    name={item && item.value ? item.value : item.label}
                    disabled={item.value === selected && selected.value}
                    onClick={event => Clicked(event.target.name)}
                  >
                    {item.label}
                  </DropdownItem>
                ))}
            </DropdownMenu>
          </Dropdown>
          <FormText color="muted">{helpText}</FormText>

          {isInvalid ? <FormText className="text-danger">{message}</FormText> : null}
        </FormGroup>
      );

    return (
      <FormGroup className="height-center">
        <Label className={className}>{label}</Label>
        <div className="auto-suggest-wclose">
          <Autosuggest
            suggestions={suggestions}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}
            shouldRenderSuggestions={() => true}
            onSuggestionSelected={(event, { suggestion }) => Clicked(suggestion.value)}
            inputProps={inputProps}
          />
          <div className="close-icon-container">
            {value.length >= 1 && (
              <Button
                className="close-icon"
                color="link"
                onClick={() => {
                  this.setState({
                    value: ""
                  });
                }}
              >
                <FontAwesomeIcon icon={["fas", "times-circle"]} size="lg" />
              </Button>
            )}
          </div>
        </div>
      </FormGroup>
    );
  }
}

DropDownComponent.defaultProps = {
  isValid: null,
  isInvalid: null,
  message: "",
  selected: { label: "", value: "" },
  className: "",
  helpText: "",
  options: null,
  name: ""
};

DropDownComponent.propTypes = {
  name: PropTypes.string,
  selected: PropTypes.shape({ value: PropTypes.string.isRequired, label: PropTypes.string.isRequired }),
  label: PropTypes.string.isRequired,
  Clicked: PropTypes.func.isRequired,
  message: PropTypes.string,
  isInvalid: PropTypes.bool,
  isValid: PropTypes.bool,
  className: PropTypes.string,
  helpText: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string.isRequired, label: PropTypes.string.isRequired })
  )
};
export default DropDownComponent;
